import {
  PumpAction,
  PumpState,
  SET_PUMPS,
  SET_PUMPS_LOADED,
  SET_PUMP_FILTER,
  SET_SELECTED_PUMP,
} from '../types'

const initialState: PumpState = {
  pumps: [],
  isPumpsLoaded: false,
  pumpFilter: {
    name: '',
    tankName: '',
    stationName: '',
    fuelName: '',
  },
}

export const pumpReducer = (
  state = initialState,
  action: PumpAction
): PumpState => {
  switch (action.type) {
    case SET_PUMPS:
      return {
        ...state,
        pumps: action.payload,
      }
    case SET_PUMPS_LOADED:
      return {
        ...state,
        isPumpsLoaded: action.payload,
      }
    case SET_PUMP_FILTER:
      return {
        ...state,
        pumpFilter: action.payload,
      }
    case SET_SELECTED_PUMP:
      return {
        ...state,
        selectedPump: action.payload,
      }
    default:
      return state
  }
}
